export default {
  placeholder: 'Filtern nach Rezept',
};
